@import "./dashboard-generic-tile/dashboard-generic-tile";
@import "./dashbord-documents/dashboard-documents-tile.scss";
@import "./dashboard-company-tile/dashboard-company-tile.scss";
@import "../../../new-result-cards/generic-subcomponents/generic-card-title/generic-card-title";
@import "../../../new-result-cards/generic-subcomponents/generic-card-description/generic-card-description";
@import "./dashboard-widgets/dashboard-widgets.scss";
@import "./dashboard-products/dashboard-products-list/dashboard-products-list.scss";
@import "./dashboard-item-header/dashboard-item-header.scss";
@import "./dashboard-products/dashboard-products-skeleton.scss";

:host {
  outline: none !important; // Prevent wrong outline from se2-keyboard class on body added by another team!
}

.dashboard__tiles {
  display: flex;
  flex-wrap: wrap;

  &--myse {
    display: grid;
    gap: 20px;

    @media (min-width: $uiaas-tablet) {
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
    }

    & > * {
      flex: 1 1 auto;
      height: 100%;
      display: flex;
      flex-flow: column nowrap;
    }
  }

  &.dashboard__tiles--gapped {
    margin-bottom: 20px;
    gap: 20px;
    & > * {
      margin: 0;
    }

    & > :nth-last-child(3) {
      flex: 1 1 100%;
    }
  }
}

.dashboard__faq {
  margin-bottom: 20px;
}

.dashboard--full-width {
  width: 100%;
}

.dashboard__products--carousel-myse {
  margin-bottom: 0;
}

.dashboard__products {
  margin-bottom: 20px;
  min-height: 300px;
}

.dashboard__products--single {
  min-height: 100px;
  margin-bottom: 20px;
}

.dashboard__tile {
  display: flex;
  flex-grow: 1;
  flex-basis: 100%;
}

.dashboard__tile-wrap {
  @extend .dashboard__tile;
  @media (max-width: $uiaas-tablet) {
    flex-wrap: wrap;
  }
  @media (min-width: $uiaas-tablet) {
    -moz-column-count: 2;
    -webkit-column-count: 2;
    column-gap: 20px;
  }
}

.dashboard__tile--half-width {
  @extend .dashboard__tile;
  flex-basis: unset;
  max-width: 49%;
}

.dashboard__tile--full-width {
  @extend .dashboard__tile;
  width: 100%;
}

.dashboard__tile--offset {
  margin-left: 25%;
  width: 100%;
  margin-bottom: 4.5%;
}

.dashboard__tile--full-width.dashboard__tile--with--v2-widget {
  @media (min-width: $uiaas-tablet) and (max-width: 999px) {
    flex-wrap: wrap-reverse;
  }
}

.order-0 {
  order: -3;
}

.order-1 {
  order: -2;
}

.order-2 {
  order: -1;
}

.dashboard-offset-left {
  @media (min-width: 999px) {
    margin-left: 20px;
  }
}

.dashboard-view {
  @media (min-width: $uiaas-tablet) {
    padding: 12px 0;
  }
  @media (min-width: $uiaas-tablet) {
    margin-top: 20px;
  }
}

.dashboard__tiles--mobile {
  @media (max-width: $uiaas-tablet) {
    padding: 0 16px 20px;
    background-color: $svs-white;
  }
}

.dashboard-minus-margins {
  @media (max-width: $uiaas-tablet) {
    margin-left: -15px;
    margin-right: -15px;
  }
}

.dashboard-card-minus-margins {
  @media (max-width: $uiaas-tablet) {
    margin-left: -20px;
    margin-right: -15px;
  }
}

.hidden {
  display: none;
}

.support-faq-widget {
  margin: 20px 0px;
}

.full-w-block {
  display: block;
  width: 100%;
}

.smart-country-selector__wrapper {
  @media (max-width: $uiaas-tablet) {
    width: 100%;
    min-height: 160px;
  }
}

.dashboard-grid {
  @media (min-width: $uiaas-tablet) {
    padding: 12px 0;
  }
  @media (min-width: $uiaas-tablet) {
    margin-top: 20px;
  }
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
}

root {
  --gap: 20px;
}

.grid-item {
  flex: 1 0 49%;
  width: 100%;
}

.grid-item.double {
  flex: 1 0 100%;
}
